export const FACEBOOK = "https://facebook.com/avpc.santiagodecompostela";
export const TWITTER = "https://twitter.com/pc_compostela";
export const INSTAGRAM = "https://instagram.com/pc_compostela";
export const TELEGRAM = "https://t.me/pc_compostela";

export const CONTACTO_TELEFONO = "(+34) 981 543 105";
export const CONTACTO_EMAIL = "pcsantiago@santiagodecompostela.gal";
export const CONTACTO_DIRECCION = "Avenida Fernando Casas Novoa, 20. Local 1 (Estadio de San Lázaro)";